import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SvgAssets } from "../../../components/icon/assets";
import { prompt } from "../../../components/modal/prompt";
import { ROOT_PATH } from "../../../routes/constants";
import { reset } from "../../auth/redux/auth-slice";
import { selectAutoLogoutMinutes } from "../../auth/redux/selector";
import { getToken } from "../../onboarding/utils";
import IdleTimer from "./idle-timer";
import { unregisterNotificationDevice } from "../../notification/redux/notification-slice";
import { SESSION_STORAGE_KEY } from "../../../utils/session-storage";

interface IdleTimerLayoutProps {
  children: React.ReactNode;
}

const IdleTimerLayout: React.FC<IdleTimerLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const autoLogoutMinutes = useSelector(selectAutoLogoutMinutes) || 15;

  const showPrompt = () => {
    const config = {
      icon: SvgAssets.notice,
      title: t("reminder_title"),
      message: t("Common.system_idle_minutes", { number: autoLogoutMinutes }),
      confirmButtonText: t("global.text.confirm"), // PHKL Custom
      onConfirm: () => {
        navigate(`${ROOT_PATH}/login`);
      },
    };
    prompt(config);
  };

  const handleIdle = () => {
    if (sessionStorage.getItem(SESSION_STORAGE_KEY.AUTH_TOKEN)) {
      const currentPath = window.location.pathname;
      const currentState = location.state;
      sessionStorage.setItem(SESSION_STORAGE_KEY.LAST_PATH, currentPath);
      sessionStorage.setItem(SESSION_STORAGE_KEY.LAST_NAVIGATE_STATE, JSON.stringify(currentState));
      sessionStorage.setItem(SESSION_STORAGE_KEY.LAST_AUTH_TOKEN, getToken());

      dispatch<any>(unregisterNotificationDevice());
      // TODO: call api to logout
      sessionStorage.removeItem(SESSION_STORAGE_KEY.AUTH_TOKEN);
      dispatch(reset());
      showPrompt();
    }
  };

  return (
    <>
      <IdleTimer onIdle={handleIdle} timeout={autoLogoutMinutes * 60 * 1000} />
      {children}
    </>
  );
};

export default IdleTimerLayout;
